(() => {
  const HEADER_OFFSET = 110;

  // Yotpo v3 upgrades the theme's `.yotpo.yotpo-main-widget` div in place, replacing
  // its classes with `.yotpo-widget-instance`; which class is present depends on
  // whether Yotpo has already run.
  const reviewsWidget = () => document.querySelector('.yotpo-widget-instance, .yotpo.yotpo-main-widget');

  // The fit pickers write the v2 `data-product-id`/`data-name` when the displayed
  // product changes; v3 only reads its own `data-yotpo-*` attributes. The v3
  // upgrade itself removes `data-product-id`, which must not trigger a sync.
  const syncWidgetProduct = (widget) => {
    const productId = widget.dataset.productId;
    if (!productId || !window.yotpoWidgetsContainer) return;
    if (widget.dataset.yotpoProductId === productId) return;
    widget.dataset.yotpoProductId = productId;
    widget.dataset.yotpoName = widget.dataset.name || '';
    widget.removeAttribute('data-yotpo-element-loaded');
    window.yotpoWidgetsContainer.initWidgets();
  };

  const widget = reviewsWidget();
  if (widget) {
    new MutationObserver(() => syncWidgetProduct(widget))
      .observe(widget, { attributes: true, attributeFilter: ['data-product-id'] });
  }

  // The v2 star widget and the `#yotpo-testimonials` links scroll to the v2 main
  // widget, which no longer exists once reviews run on v3. Instant scroll: smooth
  // scrolling is cancelled on product pages.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('a[href="#yotpo-testimonials"], .yotpo.bottomLine');
    if (!trigger) return;
    const target = reviewsWidget();
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    window.scrollTo(0, target.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET);
  }, true);
})();
